import { SET_USER_NAME, SET_AUTHENTICATION_STATUS, SET_CITIZEN } from "../../constants/actions";
import { createAction } from "redux-actions";

// Redux actions
export const setUserName = createAction(SET_USER_NAME);
export const setAuthenticationStatus = createAction(SET_AUTHENTICATION_STATUS);
export const setCitizen = createAction(SET_CITIZEN);
